module.exports = __webpack_public_path__ + "img/prize1.d97b7fd7.png";